import { styled } from "@mui/material";
import React from "react";
import Tooltip from "../../Tooltip";

const Wrapper = styled("button")<{ minWidth: string }>`
  min-width: ${(props) => props.minWidth};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.wsc.spacing[0]};
  color: ${(props) => props.theme.wsc.palette.neutral[200]};
  background: none;
  border: none;
  padding: ${(props) => props.theme.wsc.spacing[1]};
  cursor: pointer;
  border-radius: ${(props) => props.theme.wsc.radius.m};
  font-size: ${(props) => props.theme.wsc.typography.body3.fontSize};
  font-size: ${(props) => props.theme.wsc.typography.body3.fontWeight};

  &:focus {
    outline: none;
  }

  &:hover,
  &:focus {
    background: ${(props) => props.theme.wsc.palette.neutral[500]};
  }
`;

type FloatingActionBarButtonProps = {
  label?: string;
  tooltip?: string;
  icon?: React.ReactNode;
  minWidth?: string;
  onClick?: (e: React.MouseEvent<Element, MouseEvent>) => void;
};

export default function FloatingActionBarButton({
  label,
  tooltip,
  icon,
  minWidth = "70px",
  onClick,
}: FloatingActionBarButtonProps) {
  return (
    <Tooltip title={tooltip} placement="top" type="light">
      <Wrapper aria-label={label} minWidth={minWidth} onClick={onClick}>
        {icon}
        {label && <span>{label}</span>}
      </Wrapper>
    </Tooltip>
  );
}
